module.exports = __webpack_public_path__ + "static/media/Nicki Lessard.e0de7e9c.png";